var noUiSlider = require('noUiSlider');

module.exports = ['$rootScope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
    var categories = window.MG.categories;
    var allSubcategories = window.MG.subcategories;
    var countries = window.MG.countries;
    var finishes = window.MG.finishes;
    var thicknesses = window.MG.thicknesses;
    var colors = window.MG.colors;
    var showAdvancedFilters = typeof ($stateParams.finish) !== 'undefined' ||
        typeof ($stateParams.origin) !== 'undefined' ||
        typeof ($stateParams.movementMin) !== 'undefined' ||
        typeof ($stateParams.movementMax) !== 'undefined' ||
        typeof ($stateParams.colorRangeMin) !== 'undefined' ||
        typeof ($stateParams.colorRangeMax) !== 'undefined' ||
        typeof ($stateParams.abrasionResistanceMin) !== 'undefined' ||
        typeof ($stateParams.abrasionResistanceMax) !== 'undefined' ||
        typeof ($stateParams.stainResistanceMin) !== 'undefined' ||
        typeof ($stateParams.stainResistanceMax) !== 'undefined' ||
        typeof ($stateParams.etchingResistanceMin) !== 'undefined' ||
        typeof ($stateParams.etchingResistanceMax) !== 'undefined' ||
        typeof ($stateParams.heatResistanceMin) !== 'undefined' ||
        typeof ($stateParams.heatResistanceMax) !== 'undefined' ||
        typeof ($stateParams.uvResistanceMin) !== 'undefined' ||
        typeof ($stateParams.uvResistanceMax) !== 'undefined' ||
        (typeof(window.MG.showAdvancedFilters) === 'boolean' && window.MG.showAdvancedFilters);

    var subcategories = [];

    // this is duplicated for now
    var initializeSelectFacet = function (facetName, facetOptions, defaultOption) {
        var facetSetName = facetName + 'Set';
        var resetToDefault = true;
        // build an array of all options that should be in dropdown
        $scope[facetSetName] = [];
        angular.forEach(facetOptions, function (x) {
            if (typeof (x) == 'object') {
                $scope[facetSetName].push(x);
            } else {
                $scope[facetSetName].push({
                    name: x.replace('-', ' '),
                    id: x.toLowerCase()
                });
            }
        });

        // adds in a default option as first item in dropdown
        if (typeof (defaultOption) === 'object' && defaultOption !== null) {
            $scope[facetSetName].unshift(defaultOption);
        }

        // set the dropdown based on url otherwise just use the first option
        if (typeof ($stateParams[facetName]) !== 'undefined') {
            angular.forEach($scope[facetSetName], function (value, index) {
                if ($stateParams[facetName] === value.id) {
                    $scope[facetName] = $scope[facetSetName][index];
                    resetToDefault = false;
                }
            });
        }
        if (resetToDefault) {
            $scope[facetName] = $scope[facetSetName][0];
        }
    };

    var initializeMultiOptionFacet = function (facetName, facetOptions) {
        var facetSetName = facetName + 'Set';

        var activeOptions = [];

        $scope[facetSetName] = [];

        angular.forEach(facetOptions, function (x) {
            if (typeof (x) == 'object') {
                $scope[facetSetName].push(x);
            } else {
                $scope[facetSetName].push({
                    name: x.replace('-', ' '),
                    id: x.toLowerCase(),
                    active: false
                });
            }
        });

        if (typeof ($stateParams[facetName]) !== 'undefined') {
            angular.forEach($scope[facetSetName], function (value, index) {
                if ($stateParams[facetName].split(',').indexOf(value.id) !== -1) {
                    $scope[facetSetName][index].active = true;
                    activeOptions.push(value.id);
                }
            });
            $scope[facetName] = activeOptions.join(',');
        }

        if (typeof ($scope[facetName]) === 'undefined') {
            $scope[facetName] = '';
        }
        $scope.$watch(facetName, function (newVal, oldVal) {
            if (newVal == oldVal) {
                return;
            }

            if (newVal === '') {
                newVal = null;
            }

            $stateParams[facetName] = $scope[facetName];
            window.localStorage.setItem('MG.previousCount', '0');
            $state.go('search', $stateParams, { reload: true });
        });
    };

    var initializeSliderFacet = function (sliderMin, sliderMax, step, className, facetName, showToolTips) {
        var sliderEl = document.getElementsByClassName(className)[0];
        var startMin = sliderMin;
        var startMax = sliderMax;
        var minKey = facetName + 'Min';
        var maxKey = facetName + 'Max';

        if (typeof ($stateParams[minKey]) !== 'undefined') {
            startMin = parseInt($stateParams[minKey]);
        }
        if (typeof ($stateParams[maxKey]) !== 'undefined') {
            startMax = parseInt($stateParams[maxKey]);
        }

        $scope[facetName] = noUiSlider.create(sliderEl, {
            step: step,
            start: [startMin, startMax],
            tooltips: showToolTips,
            format: {
                to: function (value) {
                    return Math.round(value);
                },
                from: function (value) {
                    return Math.round(value);
                }
            },
            connect: true,
            range: {
                'min': sliderMin,
                'max': sliderMax
            }
        });

        $scope[minKey] = startMin;
        $scope[maxKey] = startMax;

        $scope[facetName].on('set', function () {
            $scope[minKey] = $scope[facetName].get()[0];
            $scope[maxKey] = $scope[facetName].get()[1];
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });

        $scope.$watch(minKey, function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            window.dataLayer.push({
                'event': 'productFilterUser',
                'category': minKey.toString(),
                'value': newVal.toString()
            });

            if (newVal === sliderMin) {
                $stateParams[minKey] = null;
            } else {
                $stateParams[minKey] = newVal;
            }

            window.localStorage.setItem('MG.previousCount', '0');
            $state.go('search', $stateParams, { reload: true });
        });

        $scope.$watch(maxKey, function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            window.dataLayer.push({
                'event': 'productFilterUser',
                'category': maxKey.toString(),
                'value': newVal.toString()
            });

            if (newVal === sliderMax) {
                $stateParams[maxKey] = null;
            } else {
                $stateParams[maxKey] = newVal;
            }

            window.localStorage.setItem('MG.previousCount', '0');
            $state.go('search', $stateParams, { reload: true });
        });
    };

    var initializeTextFacet = function (facetName) {
        var facetInputName = facetName + 'Input';

        if (typeof ($stateParams[facetName]) !== 'undefined') {
            $scope[facetName] = $stateParams[facetName];
            $scope[facetInputName] = $stateParams[facetName];
        }
    };

    var requiresUpdate = false;

    // populate list of subcategories
    angular.forEach(allSubcategories, function (x) {
        if (x.hasSlabs === true && $stateParams.category === 'slabs') {
            subcategories.push(x.name);
        } else if (x.hasTiles === true && $stateParams.category === 'tiles') {
            subcategories.push(x.name);
        }
    });

    // initialize dropdowns
    initializeSelectFacet('category', categories);
    initializeSelectFacet('subcategory', subcategories, { name: 'All', id: null });
    initializeSelectFacet('country', countries, { name: 'All', id: null });
    initializeSelectFacet('finish', finishes, { name: 'All', id: null });
    initializeSelectFacet('thickness', thicknesses, { name: 'All', id: null });

    // initialize color buttons
    initializeMultiOptionFacet('colors', colors);

    // initialize dimensions
    initializeTextFacet('lengthMin');
    initializeTextFacet('heightMin');

    // initialize sliders
    if ($stateParams.category === 'slabs') {
        if (typeof ($stateParams.priceMin) !== 'undefined' && ($stateParams.priceMin <= 500 || $stateParams.priceMin >= 5000)) {
            $stateParams.priceMin = null;
            requiresUpdate = true;
        }
        if (typeof ($stateParams.priceMax) !== 'undefined' && ($stateParams.priceMax <= 500 || $stateParams.priceMax >= 5000)) {
            $stateParams.priceMax = null;
            requiresUpdate = true;
        }
        if (requiresUpdate) {
            $state.go('search', $stateParams, { reload: true });
        }
        initializeSliderFacet(500, 5000, 50, 'price-slider', 'price', true);
        initializeSliderFacet(1, 5, 1, 'movement-slider', 'movement', false);
        initializeSliderFacet(1, 5, 1, 'color-range-slider', 'colorRange', false);
        initializeSliderFacet(1, 3, 1, 'abrasion-range-slider', 'abrasionResistance', false);
        initializeSliderFacet(1, 3, 1, 'stain-range-slider', 'stainResistance', false);
        initializeSliderFacet(1, 3, 1, 'etching-range-slider', 'etchingResistance', false);
        initializeSliderFacet(1, 3, 1, 'heat-range-slider', 'heatResistance', false);
        initializeSliderFacet(1, 3, 1, 'uv-range-slider', 'uvResistance', false);
    } else if ($stateParams.category === 'tiles') {
        if (typeof ($stateParams.priceMin) !== 'undefined' && ($stateParams.priceMin <= 0 || $stateParams.priceMin >= 70)) {
            $stateParams.priceMin = null;
            requiresUpdate = true;
        }
        if (typeof ($stateParams.priceMax) !== 'undefined' && ($stateParams.priceMax <= 0 || $stateParams.priceMax >= 70)) {
            $stateParams.priceMax = null;
            requiresUpdate = true;
        }
        if (requiresUpdate) {
            $state.go('search', $stateParams, { reload: true });
        }
        initializeSliderFacet(0, 70, 1, 'price-slider', 'price');
    }

    // handle dropdowns
    $scope.selectedDropdown = function (facetName) {
        return $scope[facetName].name;
    };

    $scope.changeDropdown = function ($event, facetName, id) {
        window.dataLayer.push({
            'event': 'productFilterUser',
            'category': facetName.toString(),
            'value': id.toString()
        });
        $event.preventDefault();
        $stateParams[facetName] = id;
        window.localStorage.setItem('MG.previousCount', '0');
        $state.go('search', $stateParams, { reload: true });
    };

    //handle toggle availability
    $scope.toggleAvailability = function () {
        window.dataLayer.push({
            'event': 'productFilterUser',
            'category': 'availability',
            'value': $scope.availability.toString(),
        });
        $stateParams['availability'] = $scope.availability;
        $state.go('search', $stateParams, { reload: true });
    };

    // handle color btn clicks
    $scope.toggleColor = function (color) {
        var activeColors = [];
        angular.forEach($scope.colorsSet, function (x) {
            if (x.id === color) {
                x.active = !x.active;
            }
            if (x.active === true) {
                activeColors.push(x.id);
            }
        });
        $scope.colors = activeColors.join(',');
        window.dataLayer.push({
            'event': 'productFilterUser',
            'category': 'Color',
            'value': color.toString()
        });
    };

    $scope.dimensionsBtnClass = function () {
        if ((typeof ($scope.lengthMinInput) !== 'undefined' && $scope.lengthMinInput.length > 0) && (typeof ($scope.heightMinInput) !== 'undefined' && $scope.heightMinInput.length > 0)) {
            return;
        }
        return 'disabled'
    };

    $scope.dimensionsBtnClick = function ($event) {
        window.dataLayer.push({
            'event': 'productFilterUser',
            'category': 'dimensions',
            'value': $scope.lengthMinInput.toString() + ' x ' + $scope.heightMinInput.toString()
        });
        $event.preventDefault();
        $stateParams.lengthMin = $scope.lengthMinInput;
        $stateParams.heightMin = $scope.heightMinInput;
        window.localStorage.setItem('MG.previousCount', '0');
        $state.go('search', $stateParams, { reload: true });
    };

    $scope.advancedFiltersClass = function () {
        if (showAdvancedFilters) {
            return 'active'
        }
    };

    $scope.toggleAdvancedFilters = function ($event) {
        $event.preventDefault();
        showAdvancedFilters = !showAdvancedFilters;
        window.MG.showAdvancedFilters = showAdvancedFilters;
        window.dataLayer.push({
            'event': 'productFilterUser',
            'category': 'toggle advanced filter',
            'value': showAdvancedFilters.toString()
        });
    };
}];
